import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppIcon from '../../components/AppIcon';
import BackButton from '../../components/BackButton';

import { formatNumber } from '../../utils/formatNumber';

const FavoritesPage = () => {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([
    {
      id: 1,
      name: 'محمد أحمد العتيبي',
      specialty: 'تصوير حفلات الزفاف',
      location: 'الرياض',
      rating: 4.9,
      reviewCount: 127,
      completedBookings: 245,
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
      verified: true,
      addedDate: '2024-01-10'
    },
    {
      id: 2,
      name: 'فاطمة السعيد',
      specialty: 'التصوير الشخصي',
      location: 'جدة',
      rating: 4.8,
      reviewCount: 89,
      completedBookings: 156,
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
      verified: true,
      addedDate: '2024-01-08'
    },
    {
      id: 3,
      name: 'خالد محمد',
      specialty: 'تصوير المناسبات',
      location: 'الدمام',
      rating: 4.7,
      reviewCount: 64,
      completedBookings: 98,
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
      verified: false,
      addedDate: '2024-01-05'
    }
  ]);

  const handleRemoveFavorite = (id) => {
    setFavorites(prev => prev?.filter(f => f?.id !== id));
  };

  const handleViewProfile = (id) => {
    navigate('/photographer-profile');
  };

  const handleBookNow = (id) => {
    navigate('/booking-wizard');
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-3xl font-bold text-foreground mb-2">المفضلة</h1>
              <p className="text-muted-foreground">
                {favorites?.length > 0
                  ? `لديك ${formatNumber(favorites?.length)} مصور في قائمة المفضلة`
                  : 'لا توجد مصورين في قائمة المفضلة'}
              </p>
            </div>
            <BackButton to={-1} label="رجوع" className="px-4 py-2 rounded-lg border border-border hover:bg-muted" />
          </div>
        </div>

        {/* Favorites Grid */}
        {favorites?.length === 0 ? (
          <div className="bg-card rounded-xl p-12 text-center border border-border">
            <AppIcon name="Heart" size={48} className="text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-foreground mb-2">لا توجد مفضلات</h3>
            <p className="text-muted-foreground mb-6">
              لم تقم بإضافة أي مصور إلى قائمة المفضلة بعد
            </p>
            <button
              onClick={() => navigate('/browse-photographers')}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-all"
            >
              <AppIcon name="Search" size={20} />
              <span>تصفح المصورين</span>
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {favorites?.map((photographer) => (
              <div
                key={photographer?.id}
                className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-lg transition-all group"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={photographer?.image}
                    alt={photographer?.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  {photographer?.verified && (
                    <div className="absolute top-3 left-3 bg-success text-white px-2 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
                      <AppIcon name="CheckCircle" size={14} />
                      <span>موثق</span>
                    </div>
                  )}
                  <button
                    onClick={() => handleRemoveFavorite(photographer?.id)}
                    className="absolute top-3 right-3 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-all"
                    aria-label="إزالة من المفضلة"
                  >
                    <AppIcon name="Heart" size={20} color="var(--color-error)" fill="var(--color-error)" />
                  </button>
                </div>

                {/* Content */}
                <div className="p-5">
                  <h3 className="text-lg font-bold text-foreground mb-1">
                    {photographer?.name}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-3">
                    {photographer?.specialty}
                  </p>

                  {/* Location */}
                  <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
                    <AppIcon name="MapPin" size={16} />
                    <span>{photographer?.location}</span>
                  </div>

                  {/* Stats */}
                  <div className="flex items-center gap-4 mb-4 pb-4 border-b border-border">
                    <div className="flex items-center gap-1">
                      <AppIcon name="Star" size={16} color="var(--color-warning)" />
                      <span className="text-sm font-semibold">{photographer?.rating}</span>
                      <span className="text-xs text-muted-foreground">({formatNumber(photographer?.reviewCount)})</span>
                    </div>
                    <div className="flex items-center gap-1 text-sm text-muted-foreground">
                      <AppIcon name="CheckCircle" size={16} />
                      <span>{formatNumber(photographer?.completedBookings)} حجز</span>
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleViewProfile(photographer?.id)}
                      className="flex-1 px-4 py-2 border border-border rounded-lg hover:bg-muted transition-all text-sm font-semibold"
                    >
                      عرض الملف
                    </button>
                    <button
                      onClick={() => handleBookNow(photographer?.id)}
                      className="flex-1 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-all text-sm font-semibold"
                    >
                      احجز الآن
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;